import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { mergePaths } from '../queries/paths';

// TSS vite/03 — unificar duplicados (admin-merge.md · 0129). Irreversible: no hay unmerge.
//   useMergePreview → dry_run (NO escribe): auto-previsualiza el impacto al elegir base+absorbida.
//   useApplyMerge   → aplica (confirm:true). Invalida las listas de la entidad afectada.

// El dry-run no muta estado → se modela como lectura (useQuery) para auto-correr y cachear.
export function useMergePreview(entity, baseId, absorbedId) {
    return useQuery({
        queryKey: ['merge', 'preview', entity, baseId, absorbedId],
        queryFn:  ({ signal }) =>
            api.post(mergePaths.merge(entity), { base_id: baseId, absorbed_id: absorbedId, dry_run: true }, { signal }).then(r => r.data),
        enabled:  !!entity && !!baseId && !!absorbedId && baseId !== absorbedId,
        retry:    false,
        gcTime:   0, // el preview es contextual a esta pantalla; no lo persistimos
    });
}

export function useApplyMerge() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ entity, baseId, absorbedId }) =>
            api.post(mergePaths.merge(entity), { base_id: baseId, absorbed_id: absorbedId, confirm: true, dry_run: false }).then(r => r.data),
        onSuccess: () => {
            // El merge repunta FK de muchas entidades: invalidamos las listas afectadas.
            ['animals', 'clients', 'farms', 'recipients', 'billing'].forEach((k) =>
                qc.invalidateQueries({ queryKey: [k] }));
        },
    });
}

// Extrae los conflictos del guard tanto del cuerpo 200 (dry-run) como de un error 409 (apply).
export function mergeConflicts(source) {
    if (!source) return [];
    if (Array.isArray(source.conflicts)) return source.conflicts;           // cuerpo del preview (200)
    const body = source.cause?.response?.data;                              // ApiError de un 409
    return Array.isArray(body?.conflicts) ? body.conflicts : [];
}
